import { actionKey as rootActionKey } from '../constants';
export var actionKey = "".concat(rootActionKey, "__WITH_CURSOR");
//# sourceMappingURL=constants.js.map